// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore, serverTimestamp } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey:
    process.env.FIREBASE_API_KEY || "AIzaSyDOlK5XjjD1ClpjHL_Mq7iX2z8xijL-MBg",
  authDomain: "github-visitors-data.firebaseapp.com",
  projectId: "github-visitors-data",
  storageBucket: "github-visitors-data.appspot.com",
  messagingSenderId: "922243309730",
  appId: "1:922243309730:web:4106e90137131a2b3c77fb",
  measurementId: "G-CD0QW79ESM",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);
const googleProvider = new GoogleAuthProvider();
const timestamp = serverTimestamp();

export { app, db, auth, storage, googleProvider, timestamp };
